import OrgPicker from "th/orgPicker";

export { OrgPicker };

customElements.define("th-org-picker", OrgPicker.CustomElementConstructor);
